import { RJSFSchema } from "@rjsf/utils";

// groupInfoSchema, cobraAdminSchema, productsSoldSchema, enrollmentSchema, docUploadSchema

export const groupInfoSchema: RJSFSchema = {
  type: "object",
  properties: {
    contactEmail: {
      type: "string",
      format: "email",
      title:
        "We would like to send a confirmation to you when this form is completed. Please provide us your email address",
    },
    companyName: {
      type: "string",
      title: "Please provide the correct legal name of the company",
    },
    uniqueId: {
      type: "string",
      title: "Please enter the unique ID provided in your email",
    },
    companyTaxId: {
      type: "string",
      title: "Please enter the Company Tax ID Number",
    },
    companyType: {
      type: "string",
      title: "Please select the type of company",
      enum: ["LLC", "Corporation", "Partnership", "Other"],
    },
    companyOrganizationDate: {
      type: "string",
      format: "date",
      title: "Please provide origination date of organization (when was the company started)",
    },
    groupWebsite: {
      type: "string",
      title: "Please provide the groups primary website",
    },
    companyAddress1: {
      type: "string",
      title: "Please provide the business location (address) information",
    },
    companyCity: {
      type: "string",
      title: "Please provide the business location city",
    },
    companyState: {
      type: "string",
      title: "Please provide the business location state",
      enum: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    },
    companyZip: {
      type: "string",
      title: "Please provide the business location zip code",
    },
    isSameBillingAddress: {
      type: "string",
      title: "Is the billing address the same address previously provided?",
      enum: ["Yes", "No"],
    },
    companyBillingAddress1: {
      type: "string",
      title: "Please supply the billing address of the group or third party",
    },
    companyBillingCity: {
      type: "string",
      title: "Please supply the billing city of the group or third party",
    },
    companyBillingState: {
      type: "string",
      title: "Please supply the billing state of the group or third party",
      enum: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    },
    companyBillingZip: {
      type: "string",
      title: "Please supply the billing zip code of the group or third party",
    },
    hasTPA: {
      type: "string",
      title: "Are you utilizing a TPA for billing purposes?",
      enum: ["Yes", "No"],
    },
    nameOfTPA: {
      type: "string",
      title: "Please provide the name of the TPA",
    },
    emailOfTPA: {
      type: "string",
      format: "email",
      title: "Please provide the Email contact information of the TPA",
    },
    policySignerName: {
      type: "string",
      title: "Please provide the Policy Signer information (Group contact that will be signing policy contracts)",
    },
    policySignerTitle: {
      type: "string",
      title: "Please provide the Policy Signer information Title (Group contact that will be signing policy contracts)",
    },
    policySignerEmail: {
      type: "string",
      format: "email",
      title:
        "Please provide the Policy Signer information email address (Group contact that will be signing policy contracts)",
    },
    policySignerPhone: {
      type: "string",
      format: "phone",
      title:
        "Please provide the Policy Signer information phone number (Group contact that will be signing policy contracts)",
    },
    policySignerAsPortalContact: {
      type: "string",
      title: "Will the policy signer be the portal contact for group administration?",
      enum: ["Yes", "No"],
    },
    portalContactName: { type: "string", title: "Portal Contact Name" },
    portalContactTitle: { type: "string", title: "Portal Contact Title" },
    portalContactEmail: {
      type: "string",
      format: "email",
      title: "Portal Contact Email Address",
    },
    portalContactPhone: {
      type: "string",
      format: "phone",
      title: "Portal Contact Phone Number",
    },
    addPrimaryContact: {
      type: "string",
      title: "Would you like to add a Primary Contact, in addition to Policy Signer?",
      enum: ["Yes", "No"],
    },
    additionalContactName: { type: "string", title: "Additional Contact Name" },
    additionalContactTitle: { type: "string", title: "Additional Contact Title" },
    additionalContactEmail: {
      type: "string",
      format: "email",
      title: "Additional Contact Email Address",
    },
    additionalContactPhone: {
      type: "string",
      format: "phone",
      title: "Additional Contact Phone Number",
    },
    billingContact: {
      type: "string",
      title: "Please provide your Billing Contact",
      enum: [
        "Policy Signer will be the billing contact",
        "Portal Contact (if different then policy signer) will be the billing contact",
        "Additional Contact Provided will be the billing contact",
        "Need to add billing contact",
      ],
    },
    billingContactName: {
      type: "string",
      title: "Please provide the name of billing contact of the group",
    },
    billingContactTitle: {
      type: "string",
      title: "Please provide the title of billing contact at the group",
    },
    billingContactEmail: {
      type: "string",
      format: "email",
      title: "Please provide the email address of the billing contact at the group",
    },
    billingContactPhone: {
      type: "string",
      format: "phone",
      title: "Please provide the phone number of the billing contact at the group",
    },
    prefferedPaymentMethod: {
      type: "string",
      title: "Please select preferred premium payment method",
      enum: ["Monthly ACH Draft", "Check"],
    },
    hasMultipleLocations: {
      type: "string",
      title: "Do you have multiple locations within the group to be set up?",
      enum: ["Yes", "No"],
    },
    numberOfLocations: {
      type: "string",
      title: "How many locations need to be set up for the group?",
    },
    billingPreference: {
      type: "string",
      title: "How would you like us to bill you?",
      enum: [
        "One bill and payment account for all locations",
        "Each Location billed separately, and paid with separate accounts",
      ],
    },
    locationTemplate: {
      type: "string",
      title: "Please Upload Completed Location Template",
      format: "data-url",
    },
  },

  required: [
    "contactEmail",
    "companyName",
    "companyTaxId",
    "companyType",
    "companyOrganizationDate",
    "groupWebsite",
    "companyAddress1",
    "companyCity",
    "companyState",
    "companyZip",
    "isSameBillingAddress",
    "hasTPA",
    "policySignerName",
    "policySignerTitle",
    "policySignerEmail",
    "policySignerPhone",
    "policySignerAsPortalContact",
    "addPrimaryContact",
    "billingContact",
    "prefferedPaymentMethod",
    "hasMultipleLocations",
  ],

  allOf: [
    {
      if: { properties: { isSameBillingAddress: { const: "No" } } },
      then: {
        required: ["companyBillingAddress1", "companyBillingCity", "companyBillingState", "companyBillingZip"],
      },
    },
    {
      if: { properties: { hasTPA: { const: "Yes" } } },
      then: { required: ["nameOfTPA", "emailOfTPA"] },
    },
    {
      if: { properties: { policySignerAsPortalContact: { const: "No" } } },
      then: {
        required: ["portalContactName", "portalContactTitle", "portalContactEmail", "portalContactPhone"],
      },
    },
    {
      if: { properties: { addPrimaryContact: { const: "Yes" } } },
      then: {
        required: [
          "additionalContactName",
          "additionalContactTitle",
          "additionalContactEmail",
          "additionalContactPhone",
        ],
      },
    },
    {
      if: { properties: { billingContact: { const: "Need to add billing contact" } } },
      then: {
        required: ["billingContactName", "billingContactTitle", "billingContactEmail", "billingContactPhone"],
      },
    },
    {
      if: { properties: { hasMultipleLocations: { const: "Yes" } } },
      then: {
        required: ["numberOfLocations", "billingPreference", "locationTemplate"],
      },
    },
  ],
};

export const cobraAdminSchema: RJSFSchema = {
  type: "object",
  properties: {
    sendCobra: {
      type: "string",
      title: "Would you like OptiMedHealth to send COBRA notices for the OptiMedHealth plan?",
      enum: ["Yes, please send COBRA notices", "No, the group has a COBRA administrator already"],
    },
    cobraAdminName: { type: "string", title: "Name of COBRA Administrator" },
    cobraAdminEmail: {
      type: "string",
      format: "email",
      title: "E-mail Contact of COBRA Administrator",
    },
    cobraAdminAddress: { type: "string", title: "Street Address for Cobra Administrator" },
    cobraAdminCity: { type: "string", title: "City for Cobra Administrator" },
    cobraAdminState: {
      type: "string",
      title: "State for Cobra Administrator",
      enum: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    },
    cobraAdminZip: { type: "string", title: "Zip Code for Cobra Administrator" },
  },

  required: ["sendCobra"],

  allOf: [
    {
      if: { properties: { sendCobra: { const: "No, the group has a COBRA administrator already" } } },
      then: {
        required: [
          "cobraAdminName",
          "cobraAdminEmail",
          "cobraAdminAddress",
          "cobraAdminCity",
          "cobraAdminState",
          "cobraAdminZip",
        ],
      },
    },
  ],
};

export const productsSoldSchema: RJSFSchema = {
  type: "object",
  properties: {
    productsSold: {
      type: "array",
      title: "Please select ALL the products sold",
      items: {
        type: "string",
        enum: [
          "GAP",
          "Limited Medical",
          "MEC (Minimum Essential Coverage)",
          "Level Funded - Major Medical",
          "Dental",
          "Vision",
          "Rx",
          "Accident",
          "Hospital",
          "Short/Long Term Disability",
          "Life",
          "HSA/FSA/HRA Administration",
          "Advantage Benefits",
        ],
      },
      uniqueItems: true,
    },
    majorMedReset: {
      type: "string",
      title: "When do the Major Medical Benefits Reset?",
      enum: ["Calendar Year", "Plan Year"],
    },
    isReplacingExistingGAP: {
      type: "string",
      title: "Is the GAP product replacing an existing GAP product current in force with the group?",
      enum: ["Yes", "No"],
    },
    currentCarrier: { type: "string", title: "Name of current carrier" },
    currentGAPCoverageType: {
      type: "string",
      title: "Please supply the coverage type for the current GAP plan",
      enum: [
        "Combined WITH Deductible",
        "Combined WITHOUT Deductible",
        "Separate WITH Deductible",
        "Separate WITHOUT Deductible",
      ],
    },
    currentGAPAddedBenefits: {
      type: "string",
      title: "Please check all of the added benefits of your existing plan?",
      enum: ["Rx", "MNSA", "OV - Copay", "OV - Covered as any illness"],
    },
    taxAndWageReport: {
      type: "string",
      title: "Please upload a copy of the group's Tax and Wage Report",
      format: "data-url",
    },
    ltdMedOrHospitalIndemnity: {
      type: "string",
      title: "Does the group currently offer Limited Benefit Medical Indemnity or Hospital Indemnity Insurance plan?",
      enum: ["Yes", "No"],
    },
    optiMedReplace: {
      type: "string",
      title: "If Yes will the OptiMed Plan replace current plan?",
      enum: ["Yes", "No"],
    },
    currentInsurer: { type: "string", title: "Name of the Current Insurer:" },
    hasDisabled: {
      type: "string",
      title: "Does the group have any employees or dependents that are disabled?",
      enum: ["Yes", "No"],
    },
    numberOfDisabledMembers: { type: "string", title: "Number of Employees/Members disabled to be insured:" },
    numberOfDisabledDependents: { type: "string", title: "Number of Dependents disabled to be insured:" },
    premiumsCollectedByPayrollDeduction: {
      type: "string",
      title: "Are the Employee/Dependent premiums collected through payroll deduction?",
      enum: ["Yes", "No"],
    },
    firstPayrollDeductionDate: { type: "string", format: "date", title: "First payroll deduction date:" },
    deductionsPerYear: { type: "string", title: "Number of payroll deductions per year:" },
    payPeriodsPerYear: { type: "string", title: "Number of pay periods per year:" },
    deductionMonths: {
      type: "string",
      title: "for 9 or 10 month payroll deductions, which months will deductions be made?",
      enum: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    },

    remittanceFrequency: {
      type: "string",
      title: "Group will remit premiums:",
      enum: ["Weekly", "Monthly", "Semi-Monthly"],
    },

    minHoursPerWeek: {
      type: "string",
      title: "Minimum required work hours per week",
      enum: ["20", "30", "Other"],
    },
  },

  required: [],

  allOf: [
    {
      if: {
        required: ["productsSold"],
        properties: {
          productsSold: { contains: { const: "GAP" } },
        },
      },
      then: {
        required: ["majorMedReset", "isReplacingExistingGAP"],
      },
    },
    {
      if: {
        required: ["isReplacingExistingGAP"],
        properties: {
          isReplacingExistingGAP: { const: "Yes" },
        },
      },
      then: {
        required: ["currentCarrier", "currentGAPCoverageType"],
      },
    },
    {
      if: {
        required: ["productsSold"],
        properties: {
          productsSold: { contains: { const: "Limited Medical" } },
        },
      },
      then: {
        required: ["ltdMedOrHospitalIndemnity", "hasDisabled", "premiumsCollectedByPayrollDeduction"],
      },
    },
    {
      if: {
        required: ["ltdMedOrHospitalIndemnity"],
        properties: {
          ltdMedOrHospitalIndemnity: { const: "Yes" },
        },
      },
      then: {
        required: ["optiMedReplace", "currentInsurer"],
      },
    },
    {
      if: {
        required: ["hasDisabled"],
        properties: {
          hasDisabled: { const: "Yes" },
        },
      },
      then: {
        required: ["numberOfDisabledMembers", "numberOfDisabledDependents"],
      },
    },
    {
      if: {
        required: ["premiumsCollectedByPayrollDeduction"],
        properties: {
          premiumsCollectedByPayrollDeduction: { const: "Yes" },
        },
      },
      then: {
        required: [
          "firstPayrollDeductionDate",
          "deductionsPerYear",
          "payPeriodsPerYear",
          "deductionMonths",
          "remittanceFrequency",
        ],
      },
    },
    {
      if: {
        required: ["productsSold"],
        properties: {
          productsSold: { contains: { const: "Level Funded - Major Medical" } },
        },
      },
      then: {
        required: ["taxAndWageReport"],
      },
    },
  ],
};

export const enrollmentSchema: RJSFSchema = {
  type: "object",
  properties: {
    enrollmentPreference: {
      type: "string",
      title: "Please select the option below for the groups enrollment",
      enum: [
        "The group would like to establish and EDI or file feed connection from their payroll system",
        "The group would like to download an OptiMedHealth Template and utilize that to submit their enrollment details",
        "The group will submit their own file to OptiMedHealth for OptiMedHealth to process. NOTE: By submitting a non-standard enrollment to OptiMedHealth the group acknowledges that the group set up may be delayed and cards may not be supplied timely.",
      ],
    },

    ediContactName: { type: "string", title: "EDI Contact Name" },
    ediContactEmail: { type: "string", title: "EDI Contact Email" },

    waitingPeriod: {
      type: "string",
      title: "Please indicate the waiting period for enrollment",
      enum: [
        "Date of Hire",
        "First of month following date of hire",
        "First of month after 30 days",
        "First of month after 60 days",
        "30 days from the first day of being Actively at Work",
        "60 days from the first day of being Actively at Work",
        "90 days from the first day of being Actively at Work",
        "Other",
      ],
    },

    waiveWaitingPeriod: {
      type: "string",
      title: "Will the waiting period be waived for all initial enrollees submitted?",
      enum: ["Yes", "No"],
    },

    eligibleClasses: {
      type: "string",
      title: "Eligible class of Employees/Members to be insured:",
      enum: ["Management", "Salaried", "Hourly", "All Full-Time", "Other"],
    },

    coverRetirees: {
      type: "string",
      title: "Are retirees to be covered under this plan?",
      enum: ["Yes", "No"],
    },

    includeEarlyRetirees: {
      type: "string",
      title: "Are you including retirees who retire before age 65?",
      enum: ["Yes", "No"],
    },

    numberOfRetirees: { type: "string", title: "How many retirees are covered under this plan?" },

    openEnrollmentEndDate: { type: "string", format: "date", title: "Open Enrollment End Date" },

    idCardDistributionMethod: {
      type: "string",
      title: "Please indicate how you would like us to distribute ID Cards",
      enum: ["Mailed to employees/members", "Mailed to corporate address for company distribution"],
    },

    isCorporateMailingSame: {
      type: "string",
      title: "Is the corporate mailing address the same as provided?",
      enum: ["Yes", "No"],
    },

    cardMailingAddress: { type: "string", title: "Please enter the mailing address where all cards will be sent" },
    cardMailingCity: { type: "string", title: "Please enter the mailing address where all cards will be sent" },
    cardMailingState: {
      type: "string",
      title: "Please enter the mailing address where all cards will be sent",
      enum: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    },
    cardMailingZip: { type: "string", title: "Please enter the mailing address where all cards will be sent" },
  },

  required: [],

  allOf: [
    {
      if: {
        required: ["enrollmentPreference"],
        properties: {
          enrollmentPreference: {
            const: "The group would like to establish and EDI or file feed connection from their payroll system",
          },
        },
      },
      then: {
        required: ["ediContactName", "ediContactEmail"],
      },
    },
    {
      if: {
        required: ["enrollmentPreference"],
        properties: {
          enrollmentPreference: {
            const:
              "The group would like to download an OptiMedHealth Template and utilize that to submit their enrollment details",
          },
        },
      },
      then: {
        required: [],
      },
    },
    {
      if: {
        required: ["coverRetirees"],
        properties: {
          coverRetirees: { const: "Yes" },
        },
      },
      then: {
        required: ["includeEarlyRetirees", "numberOfRetirees"],
      },
    },
    {
      if: {
        required: ["idCardDistributionMethod"],
        properties: {
          idCardDistributionMethod: { const: "Mailed to corporate address for company distribution" },
        },
      },
      then: {
        required: ["isCorporateMailingSame"],
      },
    },
    {
      if: {
        required: ["isCorporateMailingSame"],
        properties: {
          isCorporateMailingSame: { const: "No" },
        },
      },
      then: {
        required: ["cardMailingAddress", "cardMailingCity", "cardMailingState", "cardMailingZip"],
      },
    },
  ],
};

export const docUploadSchema: RJSFSchema = {
  type: "object",
  properties: {},
};
